import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "./Sidebar";

export default function AppLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Sidebar />
      <Box
        component="main"
        sx={{
          flex: 1,
          overflow: "auto",
          p: { xs: 2, sm: 3 },
          mt: isMobile ? "56px" : 0, // space for mobile AppBar
          mb: isMobile ? "56px" : 0, // space for mobile BottomNav
          maxWidth: "100%",
          minWidth: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
